/**
 * Blog Card Stats — InfiShark
 * Progressive enhancement: appends view counts to server-rendered stats.
 * Read time, word count, and relative date are rendered server-side in Liquid.
 */
(function () {
  'use strict';

  var VIEW_COUNTER_API = 'https://infishark-view-counter.george-14f.workers.dev/api/views';

  function createSep() {
    var s = document.createElement('span');
    s.className = 'article-card__stats-sep';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = '\u00b7';
    return s;
  }

  function createItem(text) {
    var s = document.createElement('span');
    s.className = 'article-card__stats-item';
    s.textContent = text;
    return s;
  }

  function fetchViewCounts() {
    var bars = document.querySelectorAll('.article-card__stats[data-article-id]');
    if (!bars.length) return;

    // Group bars by article ID (there may be two per card)
    var articleMap = {};
    bars.forEach(function (bar) {
      var id = bar.getAttribute('data-article-id');
      if (!/^[0-9]{1,20}$/.test(id)) return;
      if (!articleMap[id]) articleMap[id] = [];
      articleMap[id].push(bar);
    });

    Object.keys(articleMap).forEach(function (id) {
      fetch(VIEW_COUNTER_API + '/' + encodeURIComponent(id), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var count = parseInt(data.views, 10);
          if (isNaN(count) || count < 0) return;
          articleMap[id].forEach(function (bar) {
            bar.appendChild(createSep());
            bar.appendChild(createItem(count.toLocaleString() + ' views'));
          });
        })
        .catch(function () {
          // Silent — server-rendered stats still visible
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchViewCounts);
  } else {
    fetchViewCounts();
  }
})();
